import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 127.256 97.204',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Grupo_6000"
      data-name="Grupo 6000"
      transform="translate(-178.679 -852.606)"
    >
      <path
        id="heart-solid"
        className="icon"
        d="M58.866,35.868C51.887,29.921,41.507,30.99,35.1,37.6l-2.509,2.585L30.083,37.6C23.69,30.99,13.3,29.921,6.319,35.868A18.287,18.287,0,0,0,5.058,62.345L29.7,87.791a3.993,3.993,0,0,0,5.769,0L60.114,62.345a18.276,18.276,0,0,0-1.248-26.477Z"
        transform="translate(166.716 867.264) rotate(-22)"
        fill={fill}
        opacity="0.61"
      />
      <path
        id="heart-solid-2"
        className="icon"
        data-name="heart-solid"
        d="M80.223,37.283c-9.511-8.1-23.655-6.647-32.385,2.36l-3.419,3.523L41,39.644c-8.712-9.007-22.874-10.465-32.385-2.36A24.92,24.92,0,0,0,6.9,73.365L40.479,108.04a5.441,5.441,0,0,0,7.862,0L81.923,73.365a24.9,24.9,0,0,0-1.7-36.081Z"
        transform="translate(223.989 821.127) rotate(10)"
        fill={fill}
      />
    </g>
  </svg>
);

export default SVG;
